<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content SocialOrganicCampaignDetails">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Name your element</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <ul class="nav nav-tabs nav-fill" id="social_campaign_details_tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="instagram_tab" data-toggle="tab" href="#instagram" role="tab" aria-controls="instagram" aria-selected="true">INSTAGRAM</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="facebook_tab" data-toggle="tab" href="#facebook" role="tab" aria-controls="facebook" aria-selected="false">FACEBOOK</a>
                        </li>
                    </ul>

                    <div class="tab-content" id="social_campaign_details_tab_content">
                        <div class="tab-pane show active padding-top15" id="instagram" role="tabpanel" aria-labelledby="instagram_tab">
                            <div class="row margin-top20">
                                <h6 class="col-12">Select metrics</h6>

                                <div class="col-4">
                                    <div class="metrics-list-selections">
                                        <input v-model="search_metric_1" placeholder="Search for a metric..." type="search" class="form-control">

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <li v-if="getMetrics1.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                                <li v-for="metric in getMetrics1" @click="selectMetric(metric.id, $event, 1)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 align-self-center padding-x5">
                                    <button @click="applySelectedMetrics(1)" class="btn btn-info">Apply</button>
                                </div>

                                <div class="col-5">
                                    <div class="metrics-list-selected">
                                        <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics_1.length }} of {{ max_metrics_visible1 || 'TBD' }})</h6>

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <draggable v-model="selected_metrics_1" :disabled="metric_sort_disabled_1" @start="drag=true" @end="drag=false">
                                                    <li v-if="selected_metrics_1.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                                    <li v-else v-for="metric in selected_metrics_1" class="list-group-item padding-x10 padding-y5">
                                                        <span v-if="!metric.is_editing">
                                                            <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                            <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                        </span>
                                                        <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event, 1)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                        <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id, 1)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event, 1)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event, 1)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event, 1)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                        <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                        <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                                    </li>
                                                </draggable>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane padding-top15" id="facebook" role="tabpanel" aria-labelledby="facebook_tab">
                            <div class="row margin-top20">
                                <h6 class="col-12">Select metrics</h6>

                                <div class="col-4">
                                    <div class="metrics-list-selections">
                                        <input v-model="search_metric_2" placeholder="Search for a metric..." type="search" class="form-control">

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <li v-if="getMetrics2.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                                <li v-for="metric in getMetrics2" @click="selectMetric(metric.id, $event, 2)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 align-self-center padding-x5">
                                    <button @click="applySelectedMetrics(2)" class="btn btn-info">Apply</button>
                                </div>

                                <div class="col-5">
                                    <div class="metrics-list-selected">
                                        <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics_2.length }} of {{ max_metrics_visible2 || 'TBD' }})</h6>

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <draggable v-model="selected_metrics_2" :disabled="metric_sort_disabled_2" @start="drag=true" @end="drag=false">
                                                    <li v-if="selected_metrics_2.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                                    <li v-else v-for="metric in selected_metrics_2" class="list-group-item padding-x10 padding-y5">
                                                        <span v-if="!metric.is_editing">
                                                            <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                            <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                        </span>
                                                        <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event, 2)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                        <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id, 2)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event, 2)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event, 2)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event, 2)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                        <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                        <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                                    </li>
                                                </draggable>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-12">
                            <div v-for="config in element.element_configurations" class="margin-bottom10">
                                <template v-if="config.config_selector_type === 'checkbox'">
                                    <label>
                                        <p-input v-model="configurations[config.config_id]" @change="changeConfig(config.config_id, $event)" class="p-default p-curve single" type="checkbox" :value="config.config_id"> {{ config.config_name }}</p-input>
                                    </label>
                                </template>

                                <template v-if="config.config_selector_type === 'selectbox'">
                                    <h6>{{ config.config_name }}</h6>
                                    <div class="col-3 px-0">
                                        <v-select :clearable="false" :value="configurations[config.config_id] || config.config_values[0]" @input="changeConfig(config.config_id, $event)" label="name" :options="config.config_values"></v-select>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            const params = vm.customClone(this.$store.getters.getBuilderPopupParams);

            this.element              = params.element;
            this.edit_mode            = params.edit_mode || false;
            this.max_metrics_visible1 = this.element.max_metrics_visible;
            this.min_metrics_visible1 = this.element.min_metrics_visible;
            this.max_metrics_visible2 = this.element.max_metrics_visible;
            this.min_metrics_visible2 = this.element.min_metrics_visible;

            const queryString = $.param({
                client_id:  this.$store.getters.getBuilderPopupParams.client_id,
                element_id: this.element.id
            });

            _.each(this.element.element_configurations, (config) => {
                if(!this.configurations[config.config_id]){
                    this.configurations[config.config_id] = config.config_values[0];
                }
            });

            Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));

            axios.get(`/api/metrics?${queryString}`).then(metrics => {
                this.metrics_1 = vm.customClone(metrics.data);
                this.metrics_2 = vm.customClone(metrics.data);

                _.each(this.metrics_1, metric => {
                    metric.selected = false;
                    metric.applied  = _.findIndex(this.selected_metrics_1, {id: metric.id}) > -1;
                });

                _.each(this.metrics_2, metric => {
                    metric.selected = false;
                    metric.applied  = _.findIndex(this.selected_metrics_2, {id: metric.id}) > -1;
                });

                this.validate();
            });
        },

        data() {
            return {
                name:                   '',
                original_name:          '',
                element:                {},
                search_metric_1:        '',
                search_metric_2:        '',
                metrics_1:              [],
                metrics_2:              [],
                selected_metrics_1:     [],
                selected_metrics_2:     [],
                configurations:         {},
                build_disabled:         true,
                max_metrics_visible1:   null,
                min_metrics_visible1:   null,
                max_metrics_visible2:   null,
                min_metrics_visible2:   null,
                edit_mode:              false,
                metric_sort_disabled_1: false,
                metric_sort_disabled_2: false
            }
        },

        methods: {
            selectMetric(metricId, event, metricIndex) {
                const index = _.findIndex(this['metrics_' + metricIndex], {id: metricId});

                this['metrics_' + metricIndex][index].selected = !$(event.target).hasClass('active');

                this.$forceUpdate();
            },

            applySelectedMetrics(metricIndex) {
                if ((this['selected_metrics_' + metricIndex].length + _.filter(this['metrics_' + metricIndex], {selected: true}).length) > this['max_metrics_visible' + metricIndex]) {
                    this.$notify({
                        type: 'error',
                        text: `The maximum metrics for this is ${this['max_metrics_visible' + metricIndex]}. Please remove one of the current metrics if you want to add a replacement.`
                    });

                    return false;
                }

                _.each(this['metrics_' + metricIndex], metric => {
                    if (metric.selected && _.findIndex(this['selected_metrics_' + metricIndex], {id: metric.id}) === -1) {
                        metric.applied                    = true;
                        metric.selected                   = false;
                        metric.report_element_metric_axis = metricIndex;

                        this['selected_metrics_' + metricIndex].push(metric);
                    }
                });

                this.validate();
            },

            editAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing = true;
                }

                this['metric_sort_disabled_' + metricIndex] = true;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            cancelAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing = false;
                }

                this['metric_sort_disabled_' + metricIndex] = false;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            saveAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing      = false;
                    this['selected_metrics_' + metricIndex][index].new_metric_name = $(event.target).closest('li').find('.metric-edit').val().trim();

                    let formData = new FormData;
                    formData.append('metric_id', this['selected_metrics_' + metricIndex][index].metric_id);
                    formData.append('new_metric_name', this['selected_metrics_' + metricIndex][index].new_metric_name);
                    formData.append('_method', 'PUT');

                    if (this['selected_metrics_' + metricIndex][index].client_x_metric_x_data_source_id) {
                        formData.append('client_x_metric_x_data_source_id', this['selected_metrics_' + metricIndex][index].client_x_metric_x_data_source_id);
                    } else {
                        formData.append('data_source_ids', JSON.stringify([this['selected_metrics_' + metricIndex][index].data_source_id]));
                    }

                    this.ajaxSubmit({}, 'POST', `/api/metrics/client/${this.$store.getters.getBuilderPopupParams.client_id}/glossary`, formData).then(response => {
                        let queryString = $.param({
                            client_id:  this.$store.getters.getBuilderPopupParams.client_id,
                            element_id: this.element.id
                        });

                        axios.get(`/api/metrics?${queryString}`).then(metrics => {
                            let renamedMetrics = _.filter(metrics.data, metric => {
                                return metric.client_x_metric_x_data_source_id !== null;
                            });

                            _.each(renamedMetrics, metric => {
                                let renamedMetricIndex = null;

                                for (var i = 1; i <= 2; i++) {
                                    renamedMetricIndex = _.findIndex(this['metrics_' + i], {id: metric.id});

                                    if (renamedMetricIndex > -1) {
                                        this['metrics_' + i][renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                        this['metrics_' + i][renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                    }

                                    renamedMetricIndex = _.findIndex(this['selected_metrics_' + i], {id: metric.id});

                                    if (renamedMetricIndex > -1) {
                                        this['selected_metrics_' + i][renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                        this['selected_metrics_' + i][renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                    }
                                }
                            });
                        });
                    });
                }

                this['metric_sort_disabled_' + metricIndex] = false;

                this.$forceUpdate();
            },

            removeAppliedMetric(metricId, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});
                this['selected_metrics_' + metricIndex].splice(index, 1);

                index = _.findIndex(this['metrics_' + metricIndex], {id: metricId});
                if (index > -1) {
                    this['metrics_' + metricIndex][index].applied = false;
                }

                this.validate();
            },

            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                 this.name || this.$parent.generateElementName(),
                        element_id:           this.element.id,
                        element_abbreviation: this.element.abbreviation,
                        metrics_1:            this.selected_metrics_1,
                        metrics_2:            this.selected_metrics_2,
                        configurations:       this.configurations
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                 this.name || this.$parent.generateElementName(),
                            element_id:           this.element.id,
                            element_abbreviation: this.element.abbreviation,
                            metrics_1:            this.selected_metrics_1,
                            metrics_2:            this.selected_metrics_2,
                            configurations:       this.configurations
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(configId, value) {
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                }

                this.$forceUpdate();
            },

            validate() {
                this.build_disabled = true;

                if (
                    (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    )
                    && this.max_metrics_visible1 >= this.selected_metrics_1.length
                    && this.element.min_metrics_visible <= this.selected_metrics_1.length
                    && this.max_metrics_visible2 >= this.selected_metrics_2.length
                    && this.element.min_metrics_visible <= this.selected_metrics_2.length
                ) {
                    this.build_disabled = false;
                }
            }
        },

        watch: {
            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            }
        },

        computed: {
            getMetrics1() {
                return this.metrics_1.filter(metric => {
                    const metricName = metric.new_metric_name || metric.metric_name;

                    return metricName.toLowerCase().indexOf(this.search_metric_1.toLowerCase()) > -1 && metric.data_source_abbr === 'inst';
                });
            },

            getMetrics2() {
                return this.metrics_2.filter(metric => {
                    const metricName = metric.new_metric_name || metric.metric_name;

                    return metricName.toLowerCase().indexOf(this.search_metric_2.toLowerCase()) > -1 && metric.data_source_abbr === 'fbp';
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #social_campaign_details_tab_content {
        padding: 0 1.5rem 1.5rem;
        border-left: 0.1rem solid #dee2e6;
        border-right: 0.1rem solid #dee2e6;
        border-bottom: 0.1rem solid #dee2e6;
        border-bottom-left-radius: .5rem;
        border-bottom-right-radius: .5rem;
    }

    .close {
        outline: none;
    }

    .nav-tabs {
        a.nav-link {
            font-weight: 500;
            font-size: 1.2rem;
            color: #37a8cd;

            &.active {
                box-shadow: 0 -0.1rem .3rem #eeeeee;
                color: #37a8cd;
                background-color: #ffffff;
                border-color: #dee2e6 #dee2e6 #ffffff;
            }
        }
    }
</style>
